import {
  fetchRegionalUserProfile,
  normalizeRegionalUserProfile,
} from "../backend/pdxBackendClient";

/**
 * Reads the user's latest stored metadata through the protected regional
 * backend.
 *
 * The backend may satisfy this from its own user-context store or from a
 * controlled legacy fallback while migration is still in progress.
 *
 * @param {string} uid - Firebase UID kept for call-site compatibility.
 * @returns {Promise<object | null>} Latest profile JSON or null when absent.
 */
export async function fetchLatestMetadata(uid) {
  if (!uid) {
    return null;
  }

  const response = await fetchRegionalUserProfile();
  return normalizeRegionalUserProfile(response?.profile);
}
